export default __webpack_public_path__ + "static/media/640_dummy2016-asia-restaurant01-mobile-de.9314fb59.png";